import {
  EthereumStakingOrderInfo,
  EthereumStakingValidatorInfo,
} from '#/data/react-query/queries/order-list';
import React from 'react';
import { InterpreterFrom, assign, createMachine } from 'xstate';

interface MachineContext {
  originalRow: EthereumStakingOrderInfo;
  target: EthereumStakingValidatorInfo | null;
  sources: EthereumStakingValidatorInfo[] | null;
  isConsolidatableOnly: boolean;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    originalRow: null as any as EthereumStakingOrderInfo,
    target: null,
    sources: null,
    isConsolidatableOnly: true,
  },
  initial: 'destination-validator',
  states: {
    'destination-validator': {
      on: {
        NEXT: {
          target: 'source-validators',
          actions: assign((context, event) => {
            const { target } = event.data;
            return { target };
          }),
        },
      },
    },
    'source-validators': {
      on: {
        PREV: 'destination-validator',
        NEXT: {
          target: 'confirmation',
          actions: assign((context, event) => {
            const { sources } = event.data;
            return { sources };
          }),
        },
        SET_STATE: {
          actions: assign((context, event) => {
            return event.data;
          }),
        },
      },
    },
    confirmation: {
      on: {
        PREV: {
          target: 'source-validators',
        },
      },
    },
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
